import { LlmModelLifecycleState } from 'llm-model-registry';
import { OneOrManySchema } from 'notable-common';
import { z } from 'zod';
/**
 * Query parameters `GET /model-lifecycle` accepts, which reports where each model the registry
 * knows sits between upcoming and obsolete.
 */
export const FlowModelLifecycleListQuerySchema = z.object({
    state: OneOrManySchema(z.enum(LlmModelLifecycleState))
        .describe('Return only models in this state, or in any of these states.')
        .optional(),
});
//# sourceMappingURL=modelLifecycle.js.map